class SommJiGatheringGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.somm-gathering__slide'));
    this.controls = this.querySelector('.somm-gathering__controls');
    this.count = this.querySelector('.somm-gathering__count');
    this.previousButton = this.querySelector('[data-previous]');
    this.nextButton = this.querySelector('[data-next]');
    this.toggleButton = this.querySelector('[data-toggle]');
    this.track = this.querySelector('.somm-gathering__track');
    this.index = 0;
    this.paused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.interval = Math.max(Number(this.dataset.interval) || 6000, 1000);
    if (this.slides.length < 2) {
      this.slides[0]?.classList.add('is-active');
      return;
    }
    this.controls.hidden = false;
    this.show(0);
    this.previousButton.addEventListener('click', () => this.show(this.index - 1));
    this.nextButton.addEventListener('click', () => this.show(this.index + 1));
    this.toggleButton.addEventListener('click', () => this.toggle());
    this.track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
    });
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.start();
  }
  disconnectedCallback() { this.stop(); }
  show(nextIndex) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
    this.start();
  }
  toggle() {
    this.paused = !this.paused;
    this.toggleButton.textContent = this.paused ? 'Play' : 'Pause';
    this.toggleButton.setAttribute('aria-label', this.paused ? 'Start photo rotation' : 'Pause photo rotation');
    this.start();
  }
  start() {
    this.stop();
    if (!this.paused && this.slides.length > 1) this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
  }
  stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
}
if (!customElements.get('somm-ji-gathering-gallery')) customElements.define('somm-ji-gathering-gallery', SommJiGatheringGallery);
